import React from 'react';
import BottomNavMobile from '../Components/BottomNavMobile';
import './patient_profile_mobile.css';

export default function PatientProfileMobile({ patient, visits, onBack, onAddVisit, onVisitClick }) {
    
    // دالة حساب العمر
    const calculateAge = (birthDate) => {
        if (!birthDate) return 'العمر غير متوفر';
        const today = new Date();
        const birthDateObj = new Date(birthDate);
        let age = today.getFullYear() - birthDateObj.getFullYear();
        const m = today.getMonth() - birthDateObj.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDateObj.getDate())) {
            age--;
        }
        return `${age} سنة`;
    };

    return (
        <div className="mobile-pp-container" dir="rtl">
            {/* Header */}
            <div className="mobile-pp-header">
                <i className="fa-solid fa-arrow-left mobile-pp-back" onClick={onBack}></i>
                <img src="/images/Emblem_of_Syria_(2025–present).svg.png" alt="الشعار" className="mobile-pp-logo" />
                <h1 className="mobile-pp-name">{patient.name}</h1>
            </div>

            {/* Personal Info */}
            <div className="mobile-pp-info-card">
                <h3 className="mobile-pp-info-title">المعلومات الشخصية</h3>
                
                <div className="mobile-pp-info-row">
                    <div className="mobile-pp-label-group">
                        <i className="fa-solid fa-id-card mobile-pp-row-icon"></i>
                        <span className="mobile-pp-info-label">الرقم الوطني:</span>
                    </div>
                    <span className="mobile-pp-info-value">{patient.national_number}</span>
                </div>
                
                <div className="mobile-pp-info-row">
                    <div className="mobile-pp-label-group">
                        <i className="fa-solid fa-calendar mobile-pp-row-icon"></i>
                        <span className="mobile-pp-info-label">تاريخ الميلاد:</span>
                    </div>
                    <span className="mobile-pp-info-value">{patient.birth_date}</span>
                </div>
                
                

                <div className="mobile-pp-info-row">
                    <div className="mobile-pp-label-group">
                        <i className="fa-solid fa-mars-and-venus mobile-pp-row-icon"></i>
                        <span className="mobile-pp-info-label">الجنس:</span>
                    </div>
                    <span className="mobile-pp-info-value">{patient.gender || 'غير محدد'}</span>
                </div>
                
                <div className="mobile-pp-info-row">
                    <div className="mobile-pp-label-group">
                        <i className="fa-solid fa-location-dot mobile-pp-row-icon"></i>
                        <span className="mobile-pp-info-label">إحداثيات السكن:</span>
                    </div>
                    <span className="mobile-pp-info-value value-muted">{patient.residence_lat || 'غير محدد'}</span>
                </div>
                
                <div className="mobile-pp-info-row">
                    <div className="mobile-pp-label-group">
                        <i className="fa-solid fa-briefcase mobile-pp-row-icon"></i>
                        <span className="mobile-pp-info-label">إحداثيات العمل:</span>
                    </div>
                    <span className="mobile-pp-info-value value-muted">{patient.work_lat || 'غير محدد'}</span>
                </div>
            </div>

            {/* Visits Section */}
            <div className="mobile-pp-visits-wrapper">
                <div className="mobile-pp-dna-bg" style={{ backgroundImage: "url('/images/dna_pattern_blue.png')" }}></div>
                <h3 className="mobile-pp-visits-title">الزيارات السابقة ({visits.length})</h3>
                
                {visits.length > 0 ? (
                    visits.map((visit, index) => (
                        <div 
                            key={index} 
                            className="mobile-pp-visit-card"
                            onClick={() => onVisitClick(visit.id)}
                        >
                           <div className="mobile-pp-visit-top">
                    <span className="mobile-pp-visit-code">رقم الزيارة : {visit.id}</span>
                </div>
                {/* استخدام الحقل المدمج الجديد هنا */}
                <div className="mobile-pp-visit-detail">رمز المرض : {visit.display_disease_code}</div>
                <div className="mobile-pp-visit-detail">تاريخ الزيارة : {visit.diagnosis_date || "غير محدد"}</div>
                        </div>
                    ))
                ) : (
                    <p style={{ textAlign: "center", position: "relative", zIndex: 1 }}>لا توجد زيارات سابقة.</p>
                )}
            </div>
            {/* Add Visit FAB */}
            <button className="mobile-pp-fab" onClick={onAddVisit}>+</button>

            {/* Bottom Navigation */}
            <BottomNavMobile />
        </div>
    );
}